/**
 * @version:               1.0.0
 * @createTime:            2021.10.09
 * @updateTime:            2021.10.09
 * @author:                zhangju
 * @description
 ***/

export default {
    name: 'zt-detail',
    data() {
        return {
            crumbsList: [],
            id: '',
            title:'',
            fbsj: '',
            fbdw: '',
            data: {ztlmVOList:[]}
        };
    },
    mounted() {
        this.init();
    },
    watch:{
        '$route.query.id':{
            handler() {
                this.changeCrumb();
            },
            immediate:true
        }
    },
    methods: {
        init() {
            this.changeCrumb();
            this.getData();
            this.initData();
            if (this.$route.query.fbdw) {
                this.fbdw = this.$route.query.fbdw;
            }
            if (this.$route.query.fbsj) {
                this.fbsj = this.$route.query.fbsj;
            }
        },
        changeCrumb() {
            this.id = this.$route.query.id || this.$route.query.bh;
        },
        initData() {
            const bh = this.$route.query.bh;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.zt.detail.replace('{id}', bh)
            }).then((res) => {
                if (res.data.zt) {
                    this.bt = res.data.zt.bt;
                    this.fbfw = res.data.zt.fbfw;
                    if (res.data.zt.fbdw) {
                        this.fbdw = res.data.zt.fbdw;
                    }
                    if (res.data.zt.fbsj) {
                        this.fbsj = res.data.zt.fbsj;
                    }
                }
            });
        },
        // 获取专题的文章
        getData() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.zt.ztMessage.replace('{ztid}', this.id)
            }).then((res) => {
                this.data = res.data;
            });
        },
        // 查看更多
        handleMore(item) {
            this.$router.push({
                path: '/yl/zt/more',
                query: {
                    lmid: item.ztlm.bh,
                    ztid:this.id,
                    lmmc: item.ztlm.lmmc,
                    ztmc:this.title,
                    fbdw: this.fbdw,
                    fbsj: this.fbsj
                }
            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/yl/zt/xq', query: {active:'zt', id:item.bh, fbsj: this.fbsj, fbdw: this.fbdw}});
            window.open(url.href, '_blank');
        }
    }
};
//注释掉头部
$(document).ready(function() {
    if ($('#specific-page').length) { // 检查页面是否有这个元素
        $('.fd-top.noprint').hide();
        $('.fd-module-page').css('padding-top', '0px');
        // 注意：这里不需要再注释掉下面的代码了
    }

});

// $(document).ready(function() {
//     $('.fd-top.noprint').hide();
//   //  $('.fd-module-page').hide();
// });
